import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "./../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { loadHandbooks } from "@/utils/loadHandbooks";

interface IOfficeTypeForm {
  display_name: string;
}

const createOfficeTypeFields: InputField[] = [
  {
    label: "Название",
    name: "display_name",
    placeholder: "Опен-спейс",
    type: "text",
    isRequired: true,
  },
];

export function CreateOfficeTypeModal({
  disclosure,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
}) {
  const { isOpen, onOpenChange } = disclosure;

  const [modalErrors, setModalErros] = useState<ModalError[]>([]);
  const handleError = useErrorHandling();

  const onSubmit = (data: IOfficeTypeForm) => {
    return new Promise<boolean>(async (resolve, _reject) => {
      api.officeTypes
        .create({
          display_name: data.display_name,
        })
        .then((_data) => {
          loadHandbooks({ handbooks: ["offices"] });
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Создание типа офиса"
      modalErrors={modalErrors}
      fields={createOfficeTypeFields}
      isOpen={isOpen}
      isSensitiveData={false}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
    />
  );
}
